import { dialogAwarePopupContainer } from 'module/hooks/use-dialog-hosted-overlays';
import { useTranslation } from 'module/hooks/use-translation';
import { OverflowMenuVertical } from '@carbon/icons-react';
import { Button } from '@rocketlane/ui';
import { DropDownProps, Tooltip } from 'antd';
import { FC } from 'react';
import { Dropdown } from '../dropdown/dropdown';
import { IconWrapper } from '../icon-shell/icon-shell';

export interface MoreActionsDropdownProps
  extends Omit<DropDownProps, 'overlay' | 'trigger'> {
  tooltipText?: React.JSX.Element;
  dataCyValue?: string;
  stopPropogation?: boolean;
  triggerElement?: React.ReactNode;
}

export const MoreActionsDropdown: FC<
  React.PropsWithChildren<MoreActionsDropdownProps>
> = ({
  menu,
  className,
  overlayClassName,
  placement = 'bottomRight',
  tooltipText,
  dataCyValue = 'buttons.more-actions',
  stopPropogation,
  triggerElement,
  ...restProps
}) => {
  const moreActionsText = useTranslation('more_actions');

  return (
    <Dropdown
      className={className}
      overlayClassName={overlayClassName}
      menu={menu}
      placement={placement}
      trigger={['click']}
      getPopupContainer={dialogAwarePopupContainer}
      {...restProps}
    >
      <div>
        <Tooltip
          title={tooltipText ?? moreActionsText}
          getPopupContainer={dialogAwarePopupContainer}
        >
          <div>
            {triggerElement !== undefined ? (
              triggerElement
            ) : (
              <Button
                type="button"
                variant="icon"
                size="small"
                leftIcon={
                  <IconWrapper>
                    <OverflowMenuVertical size={16} />
                  </IconWrapper>
                }
                onClick={(e) => {
                  if (stopPropogation) {
                    e.stopPropagation();
                  }
                }}
                data-cy={dataCyValue}
                aria-label={moreActionsText}
              />
            )}
          </div>
        </Tooltip>
      </div>
    </Dropdown>
  );
};
